import axios from 'axios'

const state = {
  companyId: '',
  lists: [],
  filter: {},
  sort: {},
  total: 0,
  page: 1,
  perPage: 10,
  loaded: false,
}

const getters = {}

const mutations = {
  SET_COMPANY_ID(state, companyId) {
    state.companyId = companyId
  },
  SET_STATE_LOADED(state, flag) {
    state.loaded = flag
  },
  SET_LISTS_TOTAL(state, total) {
    state.total = total
  },
  SET_LISTS(state, data) {
    state.lists = data
  },
  SET_PAGE(state, { page, perPage }) {
    state.page = page
    state.perPage = perPage
  },
  SET_FILTER_PARAMS(state, params) {
    state.filter = { ...params }
  },
  SET_SORT_PARAMS(state, params) {
    state.sort = { ...params }
  },
  NEW_ITEM(state, item) {
    state.lists.concat(item)
    state.total = state.total++
  },
}

const actions = {
  setCompanyId,
  fetchLists,
  setPage,
  setFilterParams,
  setSortParams,
  removeUser,
  removeUserOfCompany,
  removeAdminOfCompany,
  removeEventAdminOfCompany,
  removeUserOfGroup,
  removeAdminOfGroup,
  removeEventAdminOfGroup,
  addNewUsersToCompany,
  addNewUsersToGroup,
  searchUsersOfCompany,
  searchUsersOfGroup,
  addUsersToCompany,
  addUsersToGroup,
  searchAdminsOfCompany,
  searchAdminsOfGroup,
  addAdminsToCompany,
  addAdminsToGroup,
  addEventAdminToCompany,
  addEventAdminToGroup,
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

function setCompanyId({ commit, state, rootState }, { companyId }) {
  commit('SET_COMPANY_ID', companyId)
}

function setPage({ commit, state, rootState }, { page, perPage }) {
  commit('SET_PAGE', { page, perPage })
  return fetchLists(
    { commit, state, rootState },
    { companyId: state.companyId }
  )
}

function setFilterParams({ commit, state, rootState }, params) {
  commit('SET_FILTER_PARAMS', params)
  return fetchLists(
    { commit, state, rootState },
    { companyId: state.companyId }
  )
}

function setSortParams({ commit, state, rootState }, params) {
  commit('SET_SORT_PARAMS', params)
  return fetchLists(
    { commit, state, rootState },
    { companyId: state.companyId }
  )
}

function fetchLists({ commit, state, rootState }, requestParams) {
  // Refresh the table
  const { companyId } = requestParams
  const { filter, page, perPage, sort } = state
  const curCompanyId = state.companyId
  let params = {}
  if (curCompanyId === Number(companyId)) {
    params = {
      companyId,
      filter,
      sort,
      page,
      per_page: perPage,
    }
    if (requestParams.eventAdminsOf !== undefined) {
      params.eventAdminsOf = requestParams.eventAdminsOf
    } else {
      commit('SET_LISTS', null)
      commit('SET_STATE_LOADED', false)
    }
  } else {
    params = requestParams
  }
  // Fetch the users from the API
  return axios
    .get('/api/v1/user', { params })
    .then((response) => {
      if (!requestParams.eventAdminsOf) {
        const { data, total } = response.data
        // save the lists in Vuex store
        if (curCompanyId === companyId) {
          commit('SET_LISTS', data)
          commit('SET_LISTS_TOTAL', total)
        }
      }
      return response.data
    })
    .finally(() => {
      if (curCompanyId === companyId) {
        commit('SET_STATE_LOADED', true)
      }
    })
}
// removeUser for admin users list
function removeUser({ commit, state, rootState }, { companyId, userId }) {
  const curCompanyId = state.companyId
  // /api/v1/user/26597
  return axios.delete(`/api/v1/user/${userId}`).then((response) => {
    if (response.data && curCompanyId === companyId) {
      // Refresh the lists
      return fetchLists({ commit, state, rootState }, { companyId })
    }
    return response.data
  })
}

// addNewUsersToCompany for admin users list | other editing form
function addNewUsersToCompany(
  { commit, state, rootState },
  { companyId, params }
) {
  const curCompanyId = state.companyId
  return axios
    .post(`/api/v1/company/${companyId}/addNewUsers`, params)
    .then((response) => {
      // add item in store
      if (curCompanyId === companyId) {
        commit('NEW_ITEM', response.data)
      }
      return response.data
    })
}

/**
 * APIs for a company or a group editing forms:
 * add new users
 * search users
 * add search users
 * remove user
 * search admin users
 * add search admin users
 * remove admin
 */

// ******** add new users to a group ********
// add new users to a group
function addNewUsersToGroup({ commit, state, rootState }, { groupId, params }) {
  return axios
    .post(`/api/v1/group/${groupId}/addNewUsers`, params)
    .then((response) => {
      return response.data
    })
}

// ******** Remove user ********
function removeUserOfCompany(
  { commit, state, rootState },
  { companyId, userId }
) {
  return axios
    .get(`/api/v1/company/${companyId}/removeUser/${userId}`)
    .then((response) => {
      return response.data
    })
}
function removeUserOfGroup({ commit, state, rootState }, { groupId, userId }) {
  return axios
    .get(`/api/v1/group/${groupId}/removeUser/${userId}`)
    .then((response) => {
      return response.data
    })
}

// ******** Remove admin ********
function removeAdminOfCompany(
  { commit, state, rootState },
  { companyId, userId }
) {
  return axios
    .get(`/api/v1/company/${companyId}/removeAdmin/${userId}`)
    .then((response) => {
      return response.data
    })
}
function removeEventAdminOfCompany(
  { commit, state, rootState },
  { companyId, userId }
) {
  return axios
    .get(`/api/v1/company/${companyId}/removeEventAdmin/${userId}`)
    .then((response) => {
      return response.data
    })
}
function removeAdminOfGroup({ commit, state, rootState }, { groupId, userId }) {
  return axios
    .get(`/api/v1/group/${groupId}/removeAdmin/${userId}`)
    .then((response) => {
      return response.data
    })
}
function removeEventAdminOfGroup(
  { commit, state, rootState },
  { groupId, userId }
) {
  return axios
    .get(`/api/v1/group/${groupId}/removeEventAdmin/${userId}`)
    .then((response) => {
      return response.data
    })
}

// ******** Search users ********
// search users in a company
function searchUsersOfCompany(
  { commit, state, rootState },
  { companyId, userTag }
) {
  return axios
    .get(`/api/v1/user/startingWith/${userTag}/companyId/${companyId}`)
    .then((response) => {
      const { data } = response
      if (data === 'not found') {
        return
      }
      return data
    })
}
// search users in a group
function searchUsersOfGroup(
  { commit, state, rootState },
  { companyId, groupId, userTag }
) {
  return axios
    .get(
      `/api/v1/user/startingWithFromCompany/${userTag}/companyId/${companyId}/groupId/${groupId}`
    )
    .then((response) => {
      const { data } = response
      if (data === 'not found') {
        return
      }
      return data
    })
}

// ******** Add search users ********
// add search users to a company
function addUsersToCompany(
  { commit, state, rootState },
  { companyId, params }
) {
  return axios
    .post(`/api/v1/company/${companyId}/addUsers`, params)
    .then((response) => {
      return response.data
    })
}
// add search users to a group
function addUsersToGroup({ commit, state, rootState }, { groupId, params }) {
  return axios
    .post(`/api/v1/group/${groupId}/addUsers`, params)
    .then((response) => {
      return response.data
    })
}

// ******** Search admin users ********
// search admin users in a company
function searchAdminsOfCompany(
  { commit, state, rootState },
  { companyId, userTag }
) {
  return axios
    .get(
      `/api/v1/user/startingWithFromCompany/${userTag}/companyId/${companyId}/groupId/0`
    )
    .then((response) => {
      const { data } = response
      if (data === 'not found') {
        return
      }
      return data
    })
}
// search admin users in a group
function searchAdminsOfGroup(
  { commit, state, rootState },
  { companyId, groupId, userTag }
) {
  return axios
    .get(`/api/v1/user/startingWithFromGroup/${userTag}/groupId/${groupId}`)
    .then((response) => {
      const { data } = response
      if (data === 'not found') {
        return
      }
      return data
    })
}

// ******** Add search admin users ********
// add search admin users to a company
function addAdminsToCompany(
  { commit, state, rootState },
  { companyId, params }
) {
  return axios
    .post(`/api/v1/company/${companyId}/addAdmins`, params)
    .then((response) => {
      return response.data
    })
}
// add search admin users to a group
function addAdminsToGroup({ commit, state, rootState }, { groupId, params }) {
  return axios
    .post(`/api/v1/group/${groupId}/addAdmins`, params)
    .then((response) => {
      return response.data
    })
}
function addEventAdminToCompany(
  { commit, state, rootState },
  { companyId, params }
) {
  return axios
    .post(`/api/v1/company/${companyId}/addEventAdmin`, params)
    .then((response) => {
      return response.data
    })
}
function addEventAdminToGroup(
  { commit, state, rootState },
  { groupId, params }
) {
  return axios
    .post(`/api/v1/group/${groupId}/addEventAdmin`, params)
    .then((response) => {
      return response.data
    })
}
